import React from "react"
import { Container } from "./style/spiner"

export default function Spiner() {
  return <Container />
}
